import {Choice, DataStatus} from 'platform/components';
import {Box, HStack, Show, Text} from 'platform/foundation';

import {useGetBranchListQuery} from '@dms/api/core';
import {useIsPublishingMultiBranchEnabledQuery} from '@dms/api/settings';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {queryParams} from '@dms/shared';

import {useQueryState} from 'shared/web';

type AdvertisingPlatformBranchChoiceProps = {
  showLabel?: boolean;
};

export function AdvertisingPlatformBranchChoice(props: AdvertisingPlatformBranchChoiceProps) {
  const [branchId, setBranchId] = useQueryState(queryParams.BRANCH_ID, true);
  const {
    data: branchList,
    isLoading: isBranchListLoading,
    isError: isBranchListError,
  } = useGetBranchListQuery();
  const {
    data: isMultiBranch,
    isLoading: isMultiBranchLoading,
    isError: isMultiBranchError,
  } = useIsPublishingMultiBranchEnabledQuery();

  const branchOptions =
    branchList?.branchListItems?.map((branch) => ({
      label: branch.marketingName,
      value: branch.id,
    })) ?? [];

  return (
    <DataStatus
      isLoading={isMultiBranchLoading || isBranchListLoading}
      isError={isMultiBranchError || isBranchListError}
    >
      <Show when={isMultiBranch}>
        <HStack align="center" spacing={2}>
          <Show when={props.showLabel}>
            <Text size="small" color="secondary">
              {i18n.t('entity.branch.labels.branch')}:
            </Text>
          </Show>
          <Box width={70}>
            <Choice
              value={branchId}
              onChange={(branchId) => setBranchId(branchId as string)}
              options={branchOptions}
              isNotClearable
              data-testid={testIds.settings.advertisingPlatforms('branch')}
            />
          </Box>
        </HStack>
      </Show>
    </DataStatus>
  );
}
